import { render, staticRenderFns } from "./JobForm.vue?vue&type=template&id=320bff55&scoped=true&"
import script from "./JobForm.vue?vue&type=script&lang=js&"
export * from "./JobForm.vue?vue&type=script&lang=js&"
import style0 from "./JobForm.vue?vue&type=style&index=0&id=320bff55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bff55",
  null
  
)

export default component.exports